import PayLaterCategory from './PayLaterCategory';

export default PayLaterCategory;
